import React from "react";
import "./App.css";
import styled from "styled-components";
import { Login } from "./login";
import Auth from './API';
import { Toaster, toast } from "sonner"
//import './components/login-video';
import { ModalImageViewer } from "./components/ModalImageViewer";

const AppContainer = styled.div`
  width: 100%;
  height: 100%;
`;

window.name = "not-logged";

(window as any)['toast'] = function (message: any, type: any) {
  if (type == "info")
    toast.info(message);
}

function App() {
  return (
    <AppContainer>
      <Auth />
      <Login />
      <ModalImageViewer></ModalImageViewer>
      <div className="z-[1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000] absolute">
        <Toaster richColors position="bottom-center" />
      </div>
    </AppContainer>
  );
}

export default App;
